<script lang="ts" setup>
import type { ElementalTypeEnum } from '@/types/elemental'
import { useAddRecentItemMutation } from '~~/src/composables/mutations/elemetal/useRecentElemental'
import { RecentItemActionEnum } from '~~/src/types/user'

interface Props {
  id?: string
  elementalTypeId: ElementalTypeEnum
}

const props = defineProps<Props>()
defineOptions({
  name: 'ProductFormContainer',
})

const user = useUser()
const { mutate: addItem } = useAddRecentItemMutation()
onMounted(() => {
  const id = props?.id
  if (!id || !user.value)
    return
  addItem({
    action: RecentItemActionEnum.Edit,
    dataId: id,
    userId: user.value.id,
  })
})
</script>

<template>
  <section relative>
    <ClientOnly>
      <ElementalForm
        :elemental-id="id"
        :elemental-type-id="elementalTypeId"
        :is-sidebar-view="false"
      />
    </ClientOnly>
  </section>
</template>
